/* eslint-disable radix */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
import { Box, Grid, Typography, Skeleton, useTheme } from '@mui/material';
import CountUp from 'react-countup';

const getVal = (val) => {
  if (Array.isArray(val)) {
    return val.length > 0 ? Number(val[0]) : 0;
  }
  return Number(val) || 0;
};

const getPrimeValue = (sales, percent) => {
  const s = getVal(sales);
  const p = Number(percent) || 0;
  return s * (p / 100);
};

const AnimatedNumber = ({ value, decimals = 0, suffix = '' }) => {
  return (
    <CountUp
      end={value}
      decimals={decimals}
      decimal=","
      separator=" "
      duration={1.2}
      suffix={suffix}
    />
  );
};

const PrimeWidget = ({ type, loading, title, salesAmount, lastSalesAmount, palierPercentage, lastMonthPalierPercentage, palier }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (type === 'primes') {
    const primeVal = getPrimeValue(salesAmount, palierPercentage);

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {/* Title */}
        <Box>
          {!loading ? (
            <Typography
              color="text.secondary"
              variant="overline"
              sx={{ fontWeight: 700, letterSpacing: '1px', fontSize: '11px', textTransform: 'uppercase' }}
            >
              {title}
            </Typography>
          ) : (
            <Skeleton variant="text" width={120} height={20} animation="wave" />
          )}
        </Box>

        {/* Palier Badge */}
        {!loading && palier?.step ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase' }}>
              Palier :
            </Typography>
            <Box
              sx={{
                px: 1.5,
                py: 0.25,
                borderRadius: '6px',
                backgroundColor: (theme) => theme.palette.mode === 'light' ? 'rgba(27, 36, 69, 0.08)' : 'rgba(237, 179, 130, 0.15)',
                color: (theme) => theme.palette.mode === 'light' ? 'primary.main' : '#edb382',
                fontWeight: 700,
                fontSize: '11px',
              }}
            >
              {palier.step}
            </Box>
          </Box>
        ) : loading ? (
          <Skeleton variant="text" width={100} height={20} animation="wave" />
        ) : null}

        {/* Prime Amount */}
        {!loading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: 'success.main' }}>
              {salesAmount && palierPercentage ? (
                <AnimatedNumber value={primeVal} decimals={2} suffix=" €" />
              ) : (
                '0,00 €'
              )}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
              {palier ? palier.step : 'Pas de primes comptabilisées'}
            </Typography>
          </Box>
        ) : (
          <Skeleton variant="text" width={150} height={40} animation="wave" />
        )}
      </Box>
    );
  }

  // Fallback / Other prime layouts (Objectif financier, etc.)
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {/* Title */}
      <Box>
        {!loading ? (
          <Typography
            color="text.secondary"
            variant="overline"
            sx={{ fontWeight: 700, letterSpacing: '1px', fontSize: '11px', textTransform: 'uppercase' }}
          >
            {title}
          </Typography>
        ) : (
          <Skeleton variant="text" width={120} height={20} animation="wave" />
        )}
      </Box>

      {!loading ? (
        <Grid container spacing={1}>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
              Objectif financier
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
              <AnimatedNumber value={25000} suffix=" €" />
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
              Valeur de prime
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: 'success.main' }}>
              <AnimatedNumber value={2.5} decimals={1} suffix=" %" />
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
              Reste
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: 'error.main' }}>
              <AnimatedNumber value={6520} suffix=" €" />
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Skeleton variant="rectangular" height={80} animation="wave" />
      )}
    </Box>
  );
};

export default PrimeWidget;
